// src/utils/sunPathStore.js
// =====================  WHERE THIS GOES  =====================
// New file. The bridge between the right-pane SunPathPanel and the
// Three.js controller in Site3DView. Panel writes params + reads
// results/status; Site3DView registers the scene controller. Neither
// imports the other. Chosen over window-events because slider drags
// are high-frequency and "Analyze day" needs a synchronous result.
// ============================================================

import { useEffect, useReducer } from 'react';

const state = {
  params: {
    month: 5, minutes: 720,      // Jun, 12:00
    lat: 22.31, lng: 73.18, tz: 5.5,
    showRays: true, showArc: true, showShadows: false, showHeat: false,
  },
  results: null,                 // { totals:{N,E,S,W,R}, hi, lo, month }
  status: { hasMassing: false, hasContext: false },
};

let updater = null, analyzer = null, activator = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const getParams = () => state.params;
export const getResults = () => state.results;
export const getStatus = () => state.status;

export function setParams(patch) {
  state.params = { ...state.params, ...patch };
  if (updater) { try { updater(state.params); } catch (e) { console.warn('[sunPath] update', e); } }
  emit();
}
export function setResults(r) { state.results = r; emit(); }
export function setStatus(s) { state.status = { ...state.status, ...s }; emit(); }

// Site3DView calls this once its controller exists.
export function registerScene({ update, analyze, setActive }) {
  updater = update || null; analyzer = analyze || null; activator = setActive || null;
}
export function clearScene() { updater = analyzer = activator = null; }

// Panel calls these on open / close so the scene only takes over the
// light + draws while Sun Path is actually on screen.
export function activate() { if (activator) activator(true); if (updater) updater(state.params); }
export function deactivate() { if (activator) activator(false); }

export function runAnalysis() {
  if (!analyzer) return null;
  const t = analyzer(state.params);
  setResults(t);
  return t;
}

export function useSunPath() {
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => { listeners.add(force); return () => listeners.delete(force); }, []);
  return {
    params: state.params, results: state.results, status: state.status,
    setParams, runAnalysis, activate, deactivate,
    hasScene: !!analyzer,
  };
}
